import { toISOString } from '@/utils/date';

function transformItem2Dto(item) {
  const dto = {
    fabricOrderID: item.id,
    ...item,
    createdAt: toISOString(item.createdAt),
    estimatedDepartureAt: toISOString(item.estimatedDepartureAt),
    estimatedDeliveryAt: toISOString(item.estimatedDeliveryAt),
    actualDeliveryAt: toISOString(item.actualDeliveryAt)
  };
  delete dto.id;
  return dto;
}

export const apiOverrides = { transformItem2Dto };
